/**
 * @fileoverview Helpers for advertisements.
 */
var $ = require('jquery');
// ES module default export requires .default when using require()
var scrollMonitorModule = require('scrollmonitor');
var scrollMonitor = scrollMonitorModule.default || scrollMonitorModule;

function Taboola(url) {
   window._taboola = window._taboola || [];
    !function (e, f, u, i) {
      e.async = 1;
      e.src = u;
      e.id = i;
      f.parentNode.insertBefore(e, f);
    }(document.createElement('script'),
    document.getElementsByTagName('script')[0],
    '//cdn.taboola.com/libtrc/theinertia/loader.js',
    'tb_loader_script');
}

Taboola.prototype.push = function (postId, url, isMobile) {
  _taboola.push({article: 'auto', url: url});
  _taboola.push({
    mode: !isMobile ? 'alternating-thumbnails-c' : 'thumbnails-rr',
    container: 'taboola-below-article-thumbnails-' + postId,
    placement: 'Below Article Thumbnails',
    target_type: 'mix'
  });
};

Taboola.prototype.flush = function () {
  _taboola.push({flush: true});
};

var inertiaTaboola = new Taboola();

function refreshAds(ads) {
  ads = ads.filter(function (ad) {
    var resp = ad.getResponseInformation();

    if (!resp) {
      return true;
    }

    return getAdvertisersToRefresh().indexOf(resp.advertiserId) > -1;
  });

  if (ads.length) {
    googletag.cmd.push(function() {
      googletag.pubads().refresh(ads);
    });
  }
}

function getAdvertisersToRefresh() {
  return [
    4666533823, // brightcom
    4548840919, // spotx
    4636524953, // rubicon
    4544607528 // google adx
  ];
}

var ads = {
  /**
   * @param {Element} el
   */
  inline: function(el) {
    var fired = false;
    var monitor = scrollMonitor.create(el);
    var playerInstance;

    var div = document.createElement('div');
    div.setAttribute('id', 'advertising-player');
    el.appendChild(div);

    var scriptLoad = $.ajax({
      url: 'https://content.jwplatform.com/libraries/gXRO1WjJ.js',
      dataType: 'script',
      cache: true
    }).done(function () {
      jwplayer.key = '/zWsfX3/Hmm2U7VUrNzOkpVyLUhWTEYdNlOscXDRb6yn4VEo';
      playerInstance = jwplayer('advertising-player');
      var adMediaContainerEl = $(div).parent();
      playerInstance.setup({
        autostart: false,
        preload: 'auto',
        playlist: [{
          "mediaid": "0YJyyoqs",
          "pubdate": "Wed, 04 Oct 2017 01:15:31 -0000",
          "sources": [
            {
              "file": "//content.jwplatform.com/manifests/0YJyyoqs.m3u8",
              "type": "hls"
            },
            {
              "duration": 1,
              "file": "//content.jwplatform.com/videos/0YJyyoqs-siSNwIfQ.mp4",
              "height": 262,
              "label": "180p",
              "type": "video/mp4",
              "width": 320
            }
          ]
        }]
      });

      playerInstance.on('ready', function() {
        playerInstance.setMute(true);
      });

      playerInstance.on('complete adComplete adError', function(msg) {
        if (msg.type === 'adError') {
          console.warn('Inertia: outstream video error', msg);
        }
        // setTimeout(function () {
          // playerInstance.remove();
          // $(el).parent().slideUp();
        // }, 50);
      });

      adMediaContainerEl.hover(function () {
        playerInstance.setMute(false);
      }, function () {
        playerInstance.setMute(true);
      });
    });

    monitor.enterViewport(function () {
      if (!fired) {
        fired = true;
        if (!playerInstance) {
          scriptLoad.done(function () {
            playerInstance.play();
          });
        } else {
          playerInstance.play();
        }
      }
    });
  },

  init: function (postId, isDynamicLoad, isMobile) {
    // var adEl = document.getElementById('ad-data-' + postId);

    // var url = adEl.getAttribute('data-ad-url');
    // var adData = JSON.parse(adEl.getAttribute('data-ad-slots'));

    // var adSlots = [];
    // googletag.cmd.push(function() {
    //   adSlots = adData.map(function (adParts) {
    //     return googletag.defineSlot(adParts[0], JSON.parse(adParts[1]), adParts[2]).addService(googletag.pubads());
    //   });

    //   googletag.pubads().disableInitialLoad();
    //   googletag.enableServices();

    //   adData.forEach(function (adParts) {
    //     googletag.display(adParts[2]);
    //   });
    // });

    // googletag.cmd.push(function() {
    //   ads.loadDynamic(adSlots, postId, url, isDynamicLoad, isMobile);
    // });
  },

  initFragment: function (frag, isMobile) {
    // var adSlots = [];
    // var adData = $(frag).find('div[id^="div-gpt-ad"]').toArray().map(function (el) {
    //   var $el = $(el);
    //   var width = parseInt($el.css('width'), 10);
    //   var height = parseInt($el.css('height'), 10);
    //   return [$el.data('section'), [width, height], $el.attr('id')];
    // });

    // googletag.cmd.push(function() {
    //   adSlots = adData.map(function (adParts) {
    //     return googletag.defineSlot(adParts[0], adParts[1], adParts[2]).addService(googletag.pubads());
    //   });

    //   adData.forEach(function (adParts) {
    //     googletag.display(adParts[2]);
    //   });
    // });

    // googletag.cmd.push(function() {
    //   ads.loadDynamic(adSlots, '', '', true, isMobile);
    // });
  },

  loadDynamic: function (slots, postId, url, isDynamicLoad, isMobile) {
    // var adMonitors = [];
    // var slotsToLoadImmediate = slots.filter(function (slot) {
    //   var id = slot.getSlotId().getDomId();
    //   var size = slot.getSizes()[0];

    //   if (size.getWidth() === 1 && size.getHeight() === 1) {
    //     return true;
    //   }

    //   var el = document.getElementById(id);
    //   if (!el) {
    //     return false;
    //   }

    //   var monitor = scrollMonitor.create(el);
    //   adMonitors.push([slot, monitor]);

    //   if (monitor.isInViewport) {
    //     return true;
    //   }

    //   monitor.one('enterViewport', function (s, m) {
    //     refreshAds([s]);
    //   }.bind(null, slot, monitor));

    //   return false;
    // });

    // refreshAds(slotsToLoadImmediate);

    // if (postId && document.getElementById('taboola-below-article-thumbnails-' + postId) && !isDynamicLoad) {
    //   inertiaTaboola.push(postId, url, isMobile);
    //   inertiaTaboola.flush();
    // }

    // setInterval(function (ams) {
    //   var visibleAds = ams.filter(function (am) {
    //     return am[1].isInViewport;
    //   });

    //   refreshAds(visibleAds.map(function (am) {
    //     return am[0];
    //   }));
    // }.bind(null, adMonitors), 60 * 1000 + (Math.random() * 3));
  }
};

module.exports = ads;
